import { props, resolveObject } from 'cerebral/tags'
import createSnackbar from '../factories/createSnackbar'

export default [
  createSnackbar(
    resolveObject({
      key: props`key`,
      params: props`params`
    }),
    'error'
  )
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/showError.js